"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _ScopedFeatureTooltip = _interopRequireDefault(require("FileManagerCore/components/permissions/ScopedFeatureTooltip"));

var _DeleteFileModal = _interopRequireDefault(require("../modals/DeleteFileModal"));

var DeleteFileContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DeleteFileContainer, _Component);

  function DeleteFileContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DeleteFileContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeleteFileContainer).call(this, props));
    _this.state = {
      isModalOpen: false
    };
    _this.handleDelete = _this.handleDelete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleButtonClick = _this.handleButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DeleteFileContainer, [{
    key: "handleDelete",
    value: function handleDelete() {
      var _this$props = this.props,
          onDelete = _this$props.onDelete,
          file = _this$props.file;
      onDelete(file);
      this.setState({
        isModalOpen: false
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        isModalOpen: false
      });
    }
  }, {
    key: "handleButtonClick",
    value: function handleButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        isModalOpen: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          file = _this$props2.file,
          isReadOnly = _this$props2.isReadOnly;
      return _react.default.createElement("span", {
        className: "p-left-3"
      }, _react.default.createElement(_ScopedFeatureTooltip.default, null, _react.default.createElement(_UIButton.default, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: this.handleButtonClick,
        disabled: isReadOnly,
        "data-test-id": "file-detail-delete-button"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "FileManagerCore.actions.delete"
      }))), this.state.isModalOpen && _react.default.createElement(_DeleteFileModal.default, {
        file: file,
        onCancel: this.handleCancel,
        onDelete: this.handleDelete
      }));
    }
  }]);
  return DeleteFileContainer;
}(_react.Component);

exports.default = DeleteFileContainer;
DeleteFileContainer.propTypes = {
  file: _propTypes.default.instanceOf(_immutable.default.Map),
  onDelete: _propTypes.default.func,
  isReadOnly: _propTypes.default.bool.isRequired
};
module.exports = exports.default;